import { AgbCodePrefix } from './agbCodePrefix';

export const ReferrerTypeCode = {
    // Non-emergency patient referred from primary care
    VT4: '4',

    // Non-emergency patient referred from other institution
    VT6: '6',

    // Own patient
    VT7: '7',
} as const;

export type ReferrerTypeCode = (typeof ReferrerTypeCode)[keyof typeof ReferrerTypeCode];

export function isReferrerTypeCode(value: string | null): value is ReferrerTypeCode {
    return Object.values(ReferrerTypeCode).includes(value as ReferrerTypeCode);
}

export function stringToReferrerTypeCode(value: string | null): ReferrerTypeCode {
    if (!isReferrerTypeCode(value)) {
        throw new Error(`Invalid ReferrerTypeCode: ${value}`);
    }

    return value as ReferrerTypeCode;
}

export function isPrimaryCareReferrer(agbCode: string) {
    const primaryCareReferrerAgbCodePrefixes = [
        `${AgbCodePrefix.generalPractitioner}0`,
        `${AgbCodePrefix.generalPractitioner}1`,
        AgbCodePrefix.orthoptist,
    ];

    return primaryCareReferrerAgbCodePrefixes.some((prefix) => agbCode.startsWith(prefix));
}

export function isOtherInstitutionReferrer(agbCode: string) {
    const otherInstitutionReferrerAgbCodePrefixes = [
        AgbCodePrefix.medicalSpecialist,
        AgbCodePrefix.dentist,
        AgbCodePrefix.occupationalPhysician,
        AgbCodePrefix.otherPhysicians,
    ];

    return otherInstitutionReferrerAgbCodePrefixes.some((prefix) => agbCode.startsWith(prefix));
}
